import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { UserService } from "app/auth/service";
import { ICollaboratorCost } from "./models/collaborator-costs";

@Injectable({
  providedIn: "root",
})
export class CollaboratorsService {
  constructor(
    private _httpClient: HttpClient,
    private _userService: UserService,
  ) {}

  async getCollaboratorList() {
    return this._httpClient.get("/collaborator").toPromise();
  }

  async getCollaborator(hash: any) {
    return this._httpClient.get(`/collaborator/${hash}`).toPromise();
  }

  async createCollaborator(data: any = {}) {
    return this._httpClient
      .post("/collaborator", data)
      .toPromise()
      .then((response: any) => {
        this._userService.getAllUsers();
        return response;
      });
  }

  async updateCollaborator(hash: string, data: any = {}) {
    return this._httpClient
      .put(`/collaborator/${hash}`, data)
      .toPromise()
      .then((response) => {
        this._userService.getAllUsers();
        return response;
      });
  }

  async deleteCollaborator(hash: string) {
    return this._httpClient
      .delete(`/collaborator/${hash}`)
      .toPromise()
      .then((response) => {
        this._userService.getAllUsers();
        return response;
      });
  }

  async disableLogin(hash: string, data: any = {}) {
    return this._httpClient.post(`/collaborator/disable-login/${hash}`, data).toPromise();
  }

  async deleteCollaboratorAttachment(id: string) {
    return this._httpClient.delete(`/collaborator/attachment/${id}`).toPromise();
  }

  async enableLogin(hash: string) {
    return this._httpClient.post(`/collaborator/enable-login/${hash}`, {}).toPromise();
  }

  async updateCollaboratorLanding(data: any = {}) {
    return this._httpClient.post("/collaborator/send-masterdata", data).toPromise();
  }

  async updateCostCollaborator(id: number, data: { monthly_cost: string }) {
    return this._httpClient.put<{ monthly_cost: string }>(`/collaborator/monthly-cost/${id}`, data).toPromise();
  }

  async getCollaboratorsCostList(month: string, year: string) {
    return this._httpClient.get<ICollaboratorCost[]>(`/collaborator/monthly-cost/${month}/${year}`).toPromise();
  }
}
